import type { Action } from "svelte/action"
import { isHeroVisible, location } from "../store"
import { initialLocale, localePattern, locales } from "../i18n"
import { get } from "svelte/store"
export const onNavigateCallbacks: ((to: string, from: string) => void)[] = []

export function onNavigate(callback: (to: string, from: string) => void) {
    onNavigateCallbacks.push(callback)
}
export function removeOnNavigate(callback: (to: string, from: string) => void) {
    const index = onNavigateCallbacks.indexOf(callback)
    if (index !== -1) {
        onNavigateCallbacks.splice(index, 1)
    }
}

export const spaLink: Action<HTMLAnchorElement> = (node) => {
    const onClick = (event: MouseEvent) => {
        if (node.dataset.spaPrevent && node.dataset.spaPrevent !== "false") {
            return
        }
        const anchor = event.currentTarget as HTMLAnchorElement
        if ((anchor.target === "" || anchor.target === "_self") && anchor.href.startsWith(window.location.origin)) {
            event.preventDefault()
            const currentUrl = window.location.pathname + window.location.search + window.location.hash
            const newUrl = anchor.pathname + anchor.search + anchor.hash
            if (currentUrl === newUrl) {
                onNavigateCallbacks.forEach((callback) => {
                    callback(newUrl, currentUrl)
                })
                window.scrollTo(0, 0)
                return
            }
            spaNavigate(newUrl)
        }
    }

    node.addEventListener("click", onClick)

    return {
        destroy() {
            node.removeEventListener("click", onClick)
        },
    }
}

export function correctI18nPath(pathname?: string): boolean {
    let path = pathname ? pathname : get(location).path
    let included = false
    locales.forEach((locale) => {
        if (path.startsWith(`/${locale}`)) included = true
    })
    if (included) return false

    if (path.endsWith("/")) path = path.slice(0, -1)

    const match = localePattern.exec(path)
    if (match) {
        const locale = match[1]
        const rest = path.slice(locale.length + 1)
        if (locale === "de") return
        const newPath = rest ? (rest.startsWith("/") ? rest : `/${rest}`) : ""
        spaNavigate(`/de${newPath}`, { corrected: true })
    } else spaNavigate(`/${initialLocale}${path}`, { corrected: true })
    return true
}
export const spaNavigate = (to: string, options?: { replace?: boolean; corrected: boolean }) => {
    window.scrollTo(0, 0)
    if (!options?.corrected && correctI18nPath(to)) {
        return
    }
    //scroll to top of page
    setTimeout(() => {
        window.scrollTo(0, 0)
    }, 100)
    isHeroVisible.set(false)
    onNavigateCallbacks.forEach((callback) => {
        const currentUrl = window.location.pathname + window.location.search + window.location.hash
        callback(to, currentUrl)
    })
    if (options?.replace) {
        window.history.replaceState(null, "", to)
    } else {
        window.history.pushState(null, "", to)
    }
}

export const spaBack = () => {
    window.history.back()
}
